import { InternalAxiosRequestConfig } from 'axios'
import { v4 as uuidv4 } from 'uuid'
export const spTraceInterReq = (request: InternalAxiosRequestConfig) => {
    request.headers['X-SP-Trace-Id'] = uuidv4()
    return request
}
